export {default as topology} from "./src/topology";



//////////////////
// WEBPACK FOOTER
// ./~/topojson/~/topojson-server/index.js
// module id = 540
// module chunks = 0